import { FILE_DOWNLOAD } from 'constants/urls';
import { getToken } from './token';

export const getFileUrl = id => (
    id ? `/api${FILE_DOWNLOAD.stringify({ id })}?token=${getToken()}` : null
);
